import apiClient from "../../../api/apiClient";

//Base URL

const BASE_PATH = "/admin/panchang";

export const createPanchang = async (createPanchangValues) => {
  const response = await apiClient.post(BASE_PATH + "/", createPanchangValues);
  return response.data;
};

export const getPanchang = async () => {
  const response = await apiClient.post(`${BASE_PATH}/get`, {});
  return response.data;
};

export const getPanchangDays = async (dayId) => {
  const params = new URLSearchParams();
  dayId && params.set("day-id", dayId);
  const response = await apiClient.get(`${BASE_PATH}/days?${params}`);
  return response.data;
};

export const updatePanchang = async (updatePanchangValues) => {
  const response = await apiClient.put(`${BASE_PATH}/`, updatePanchangValues);
  return response.data;
};
